"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var omit_1 = __importDefault(require("lodash/omit"));
var creatable_1 = __importDefault(require("react-select/creatable"));
var Button_1 = __importStar(require("../Button"));
var config_1 = require("../config");
var Input_1 = require("../Input");
var LocaleProvider_1 = __importDefault(require("../LocaleProvider"));
var b = config_1.block("autocreate");
var AutoCreateInput = /** @class */ (function (_super) {
    __extends(AutoCreateInput, _super);
    function AutoCreateInput(props) {
        var _this = _super.call(this, props) || this;
        _this.updateLocale = function () {
            _this.forceUpdate();
        };
        _this.renderCreate = function (_value) {
            var localization = LocaleProvider_1.default.locs.auto_create;
            var _a = _this.props.createCardConfig, createButtonLabel = _a.createButtonLabel, createButtonVariant = _a.createButtonVariant, message = _a.message;
            var variant = createButtonVariant || Button_1.ButtonVariant.Primary;
            return (react_1.default.createElement("div", { className: b("not_found") },
                react_1.default.createElement("div", { className: "message" }, message || localization.message),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Button_1.default, { variant: variant }, createButtonLabel || localization.createButtonLabel))));
        };
        _this.renderOption = function (option, _labelMeta) {
            var _a = option, label = _a.label, __isNew__ = _a.__isNew__;
            return react_1.default.createElement("div", { style: { padding: __isNew__ ? 0 : 10 } }, label);
        };
        _this.handleOnInputChange = function (newValue, _actionMeta) {
            if (_this.props.onInputChange) {
                _this.props.onInputChange(newValue);
            }
        };
        _this.handleOnChange = function (value, _action) { return __awaiter(_this, void 0, void 0, function () {
            var __isNew__, entity;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        __isNew__ = value.__isNew__;
                        entity = omit_1.default(value, ["__isNew__"]);
                        if (!__isNew__) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.onCreate(entity)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.props.onChange(entity);
                        return [2 /*return*/];
                }
            });
        }); };
        LocaleProvider_1.default.on(_this.updateLocale);
        return _this;
    }
    AutoCreateInput.prototype.componentWillUnmount = function () {
        LocaleProvider_1.default.off(this.updateLocale);
    };
    AutoCreateInput.prototype.render = function () {
        var localization = LocaleProvider_1.default.locs.auto_create;
        var _a = this.props, className = _a.className, disabled = _a.disabled, variant = _a.variant, value = _a.value, placeholder = _a.placeholder;
        var cn = b({
            grey: variant === Input_1.InputVariant.Grey,
            white: variant === Input_1.InputVariant.White,
        }).mix(className);
        return (react_1.default.createElement(creatable_1.default, { formatOptionLabel: this.renderOption, formatCreateLabel: this.renderCreate, isClearable: this.props.isClearable, onChange: this.handleOnChange, onInputChange: this.handleOnInputChange, options: this.props.options || [], className: cn, classNamePrefix: b(), isDisabled: disabled, value: value, placeholder: placeholder || localization.select }));
    };
    return AutoCreateInput;
}(react_1.Component));
exports.default = AutoCreateInput;
//# sourceMappingURL=index.js.map